<template>
    <app-layout :title="title">
    
    <template #header>
        <h4>{{title}}</h4>
    </template>

    <div v-html="$page.props.global_config.aboutus.about_us">
    </div>
      
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'

    export default {
        components: {
            AppLayout,
        },
        data(){
            return {
                title: 'About Us'
            }
        }
    }
</script>